import type { QualifyingLifeEvent } from '@hc-frontend/core-types';

const qualifyLifeEventCode: Record<QualifyingLifeEvent, number> = {
  Coverage: 0,
  LostCoverage: 1,
  Marriage: 2,
  Divorce: 3,
  Baby: 4,
  Moved: 5,
  LostDependentStatus: 6,
  IncomeChanged: 7,
  ShortTerm: 8,
  ChangeImmigrationStatus: 9,
  Other: 10,
  None: 11,
};

export function qualifyLifeEventCodeToQuotIt(
  code: QualifyingLifeEvent,
): number {
  return qualifyLifeEventCode[code];
}
